import { render, staticRenderFns } from "./DataBuildImportAccountToCampaign.vue?vue&type=template&id=51d04b08&scoped=true"
import script from "./DataBuildImportAccountToCampaign.vue?vue&type=script&lang=js"
export * from "./DataBuildImportAccountToCampaign.vue?vue&type=script&lang=js"
import style0 from "./DataBuildImportAccountToCampaign.vue?vue&type=style&index=0&id=51d04b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d04b08",
  null
  
)

export default component.exports